import React from 'react';
import styles from './index.module.less';
import { IVCourseResult } from '@/types';
import classNames from 'classnames';

interface IProps {
    dataSource: IVCourseResult['projectList'];
    activeKey: number;
    handleClick: (activeKey: number, active: IVCourseResult['projectList'][number]) => void;
}

const ProjectTabs = (props: IProps) => {
    const { dataSource, activeKey, handleClick } = props;
    return (
        <div className={styles['project-tabs']}>
            <div className={styles['project-tabs-list']}>
                {dataSource.map(item => (
                    <div
                        className={classNames(styles['project-tabs-tab'], {
                            [styles['active']]: item.id === activeKey,
                        })}
                        key={item.id}
                        onClick={() => {
                            if (item.id !== activeKey) {
                                handleClick(item.id, item);
                            }
                        }}
                    >
                        <span className={styles['project-tabs-tab-title']}>{item.name}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ProjectTabs;
